import React from "react";
import Avatar from "@mui/material/Avatar";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import LockResetIcon from "@mui/icons-material/LockReset";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import LoadingButton from "@mui/lab/LoadingButton";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import PasswordComponent from "../Components/PasswordComponent";

function ResetPassword() {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  console.log(token);

  async function resetPassword({ newPassword, confirmPassword:confirmNewPassword }) {
    try{
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/v1/auth/change-password?token=${token}`, {newPassword, confirmNewPassword})
      console.log(response.data)
      setLoading(false)
      navigate("/sign-in")
      toast.success(`You have successfully changed your password`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        });
    }catch(err){
      setLoading(false)
      toast.error(`${err.message}`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        });
      console.log(err);
    }
  }
  const handleSubmit = async (event) => {
    setLoading(true)
    event.preventDefault();
    if (newPassword === confirmPassword) {
      resetPassword({ newPassword, confirmPassword });
    } else {
      setLoading(false)
      toast.error(`New Password & confirm Password is not maching`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        });
    }
  };
  return (
    <>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
            <LockResetIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Reset Your Password
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit}
            method="POST"
            sx={{ mt: 1 }}
          >
            
            <PasswordComponent name="new-password" label="New Password" value={newPassword} setValue={setNewPassword} />

            <PasswordComponent name="confirm-new-password" label="Confirm New Password" value={confirmPassword} setValue={setConfirmPassword} />

            <LoadingButton
              type="submit"
              fullWidth
              loading={loading}
              endIcon={<LockResetIcon />}
              loadingPosition="end"
              variant="contained"
              sx={{ mt: 3, mb: 2, bgcolor: "secondary.main" }}
            >
              Reset Password
            </LoadingButton>
          </Box>
        </Box>
        <ToastContainer />
      </Container>
    </>
  );
}

export default ResetPassword;
